/* eslint-disable camelcase */
import {useLocation, useParams} from 'react-router-dom';

/*
 * Helpers.
 */

export interface SurveyQueryData {
  score?: number;
  slug?: string;
  includeContactInput?: boolean;
}

export function useSurveyQueryData(): SurveyQueryData {
  const {search} = useLocation();
  const query = new URLSearchParams(search);

  const slugParam = query.get('slug');
  const slug = slugParam ? String(slugParam) : undefined;
  const scoreParam = query.get('score');
  const score = scoreParam ? Number(scoreParam) : undefined;
  const contactParam = query.get('handleRequired');
  const contact = String(contactParam) === 'true';

  return {
    score,
    slug,
    includeContactInput: contact,
  };
}

export interface SurveyRouterData extends SurveyQueryData {
  msgUid?: string;
}

type ParamTypes = {
  company_slug: string;
  msg_uid: string;
};

export function useSurveyRouterData(): SurveyRouterData {
  const {company_slug, msg_uid} = useParams<ParamTypes>();
  const {score, slug, includeContactInput} = useSurveyQueryData();

  const actualSlug = company_slug || slug;

  return {
    msgUid: msg_uid,
    slug: actualSlug,
    score,
    includeContactInput,
  };
}
